'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = exports.IconMenu = undefined;

var _IconMenu2 = require('./IconMenu');

var _IconMenu3 = _interopRequireDefault(_IconMenu2);

var _MenuItem2 = require('../MenuItem/MenuItem');

var _MenuItem3 = _interopRequireDefault(_MenuItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.IconMenu = _IconMenu3.default;
exports.MenuItem = _MenuItem3.default;
exports.default = _IconMenu3.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/IconMenu/index.js
 ** module id = 875
 ** module chunks = 0
 **/